import { CuratedModelSection, type CuratedModelSectionProps } from "./CuratedModelSection";

export function FlagshipSection(props: Omit<CuratedModelSectionProps, "variant">) {
  return <CuratedModelSection {...props} variant="flagship" />;
}
